<template>
	<v-container fluid style="height:100%">
		<div class="chat-container d-flex">
			<v-row class="fill-height" style="width: 100%;">
				<v-col cols="12" md="4" class="fill-height pa-0" style="max-width: 690px;">
					<div v-if="creatingRoom" :style="'height:'+$store.getters['general/availableHeight']+'px;'" style="overflow: scroll;">
						<CreateChatRoomEmbedded
							:selectChatRoom="selectChatRoom"
							@close="creatingRoom = false"
						/>
					</div>
					<div class="chat-room-list-container pt-2" :style="'height:'+$store.getters['general/availableHeight']+'px;'" v-else>
						<div>
							<div class="d-flex align-center">
								<v-tooltip bottom>
									<template #activator="{ on, attrs }">
										<v-btn
											tile
											depressed
											text
											x-large
											class="d-flex flex-1 flex-grow-1"
											v-bind="{ ...attrs }"
											v-on="{ ...on }"
											@click="creatingRoom = true"
										>
										<div class="d-flex flex-column">
											<p class="mb-0 caption">Nuevo Chat</p>
											<v-icon>mdi-message-plus-outline</v-icon>
										</div>
										</v-btn>
									</template>
									<span>Nuevo Chat</span>
								</v-tooltip>
								<v-divider vertical></v-divider>
								<div class="d-flex flex-column align-center justify-end mb-0 mx-2" style="gap: 5px;">
									<div class="d-flex align-center mb-0 mx-2" style="width: 100%;">
										<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
										<v-text-field
											v-model="search"
											outlined
											dense
											hide-details
											item-text="name"
											item-value="id"
											return-object
											clearable
											label="Búsqueda"
											class="mb-0 custom-height-search custom-height-calendar"
											color="#524D4D"
											@input="sendToSearch"
										></v-text-field>
									</div>
									<v-divider class="my-0" style="width: 100%;"></v-divider>
									<div class="d-flex align-center flex-wrap flex-grow-1 mb-1" style="gap: 5px;">
										<v-btn
											depressed
											:color="selectedFilter == 1 ? '#FF120B':'#524D4D'"
											:outlined="selectedFilter != 1"
											:dark="selectedFilter == 1"
											x-small
											class="flex-grow-1"
											@click="selectedFilter = 1"
										>
											<p class="mb-0" style="font-size: 10px;">Todos</p>
										</v-btn>
										<v-btn
											v-if="!isClient"
											depressed
											:color="selectedFilter == 2 ? '#FF120B':'#524D4D'"
											:outlined="selectedFilter != 2"
											:dark="selectedFilter == 2"
											x-small
											class="flex-grow-1"
											@click="selectedFilter = 2"
										>
											<p class="mb-0" style="font-size: 10px;">Prospectos</p>
										</v-btn>
										<v-btn
											v-if="!isClient"
											depressed
											:color="selectedFilter == 3 ? '#FF120B':'#524D4D'"
											:outlined="selectedFilter != 3"
											:dark="selectedFilter == 3"
											x-small
											class="flex-grow-1"
											@click="selectedFilter = 3"
										>
											<p class="mb-0" style="font-size: 10px;">Clientes</p>
										</v-btn>
										<v-btn
											depressed
											:color="selectedFilter == 4 ? '#FF120B':'#524D4D'"
											:outlined="selectedFilter != 4"
											:dark="selectedFilter == 4"
											x-small
											class="flex-grow-1"
											@click="selectedFilter = 4"
										>
											<p class="mb-0" style="font-size: 10px;">{{isClient ? 'Profesionales':'Profesionales / Empresas'}}</p>
										</v-btn>
										<v-btn
											depressed
											:color="selectedFilter == 5 ? '#FF120B':'#524D4D'"
											:outlined="selectedFilter != 5"
											:dark="selectedFilter == 5"
											x-small
											class="flex-grow-1"
											@click="selectedFilter = 5"
										>
											<p class="mb-0" style="font-size: 10px;">Chat Grupal de Proyectos</p>
										</v-btn>
									</div>
								</div>
							</div>
							<v-progress-linear v-if="loadingChatRooms" indeterminate color="#FF120B"></v-progress-linear>
							<v-divider class="mt-2"></v-divider>
						</div>
						<div class="chat-rooms-container">
							<div class="chat-list-item d-flex align-center px-2 py-2"
								v-for="(room, index) in chatsRooms" :key="index"
								:class="{ 'selected-room': selectedChatRoomId === room.id }"
								@click="selectChatRoom(room)">
								<v-avatar color="#cacaca" size="35px" class="mr-2">
									<img
										v-if="room.users?.length > 0 && room.users[0]?.user?.profile?.avatar"
										:src="room.users[0].user.profile.avatar"
									/>
									<v-icon v-else dark small>mdi-account</v-icon>
								</v-avatar>
								<div class="d-flex flex-column flex-grow-1">
									<div class="d-flex flex-column">
										<div class="d-flex align-center justify-space-between" style="gap: 5px;">
											<v-chip
												x-small
												dark
												:style="getRoomTypeStyle(room)"
											>
												{{ getRoomType(room) }}
											</v-chip>
											<div v-if="room.unseen_message_count > 0" class="custom-badge-counter-chat">
												<p class="mb-0 white--text" :style="{ fontSize: room.unseen_message_count > 10 ? '10px' : '12px' }">{{ room.unseen_message_count > 99 ? '+99' : room.unseen_message_count }}</p>
											</div>
										</div>
										<div class="d-flex align-center justify-space-between">
											<p class="mb-0 font-weight-bold body-2">{{getRoomName(room)}}</p>
											<div class="d-flex align-center" v-if="getRoomTypeIndicator(room) == 'project_line'" style="gap: 2px;">
												<p class="mb-1 caption font-weight-bold">LP{{ getRoomPl(room) }}</p>
												<ProjectLineAssociationMenu v-if="room.morphable_type == 'App\\Models\\ProjectLine'" :projectLineAssociations="projectLineAssociations(room)" />
											</div>
										</div>
									</div>
									<div class="d-flex align-center justify-space-between">
										<div>
											<p class="mb-0 font-weight-bold" style="font-size: 10px;" v-if="!!getRoomClientName(room) && getRoomTypeIndicator(room) != 'project_line'">{{ getRoomClientName(room) }}</p>
											<p class="mb-0" style="font-size: 10px;">{{ getRoomClientEmail(room) }}</p>
										</div>

										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<div
													class="d-flex align-center"
													v-if="room.last_message?.created_at || room.created_at"
													v-bind="attrs"
													v-on="on">
													<v-icon x-small>{{room.last_message?.created_at ? 'mdi-message-text-clock-outline':'mdi-account-clock-outline'}}</v-icon>
													<p class="mb-0 text-right" style="font-size: 10px;width: 75px;">{{ room.last_message?.created_at || room.created_at | toDateTime }}</p>
												</div>
											</template>
											<span>{{room.last_message?.created_at ? 'Fecha del último mensaje':'Fecha creación del chat'}}</span>
										</v-tooltip>
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-col>
				<v-col cols="12" md="8" class="pa-0">
					<div class="chatbox-container fill-height" v-if="!selectedChatRoomId">
						<div class="messages-container nomessages d-flex align-center justify-center">
							<v-icon size="40">mdi-chat</v-icon>
							<p class="mb-0">Selecciona una conversación</p>
						</div>
					</div>
					<div class="chatbox-container fill-height" :style="'height:'+$store.getters['general/availableHeight']+'px;'" v-else>
						<MessagesFullView :selectedChatRoomId="selectedChatRoomId" @clearSelectedRoom="selectedChatRoomId = null"/>
					</div>
				</v-col>
			</v-row>
		</div>
	</v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import MessagesFullView from '@/components/Views/Chat/MessagesFullView'
import CreateChatRoomEmbedded from '@/components/Views/Chat/CreateChatRoomEmbedded'
import {getChatRoomMessages, addMessageToChatRoom, createUserChatRoom} from '@/helpers/api/chats'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import ProjectLineAssociationMenu from '@/components/Views/Projects/Parts/ProjectLineAssociationMenu'

export default {
	components: {MessagesFullView, CreateChatRoomEmbedded, ProjectLineAssociationMenu},
	data() {
		return {
			search: '',
			selectedFilter: 1,
      options: {
        page: 1,
        itemsPerPage: 1000,
        sortBy: [],
        sortDesc: [],
      },
			new_message: null,
			loadingAddChat: false,
			conversationMessages: [],
			selectedChatRoomId: null,
			requestInterval: null,
			creatingRoom: false
		};
	},
  computed: {
		isClient(){
			return this.$checkPermissions(['client_capabilities'])
		},
		queryRoute(){
			return this.$route.query
		},
		roomsFromSearch(){
			if(typeof this.search === 'string' && this.search.trim() !== ''){
				const users = this.$store.state.users.usersList.filter(user => {
					return (
						( user.profile?.name.toLowerCase().includes(this.search.toLowerCase()) ||
						user.email.toLowerCase().includes(this.search.toLowerCase()) ) &&
						user.id != this.$store.state.user?.userInfo?.id
					)
				})
				return users
			}
			return null
		},
		loadingChatRooms(){
			return this.$store.state.chats.loadingChats
		},
		chatsRooms() {
			// const search = this.search?.toLowerCase();

			// if (search && search.length > 3) {
			// 	return this.$store.state.chats.chats.filter(room => {
			// 		const name = room.morphable?.name?.toLowerCase() || '';
			// 		const details = room.morphable?.info?.project_details?.toLowerCase() || '';
			// 		return name.includes(search) || details.includes(search);
			// 	});
			// }
			if(this.selectedFilter == 2){
				// Prospectos
				return this.$store.state.chats.chats.filter(chat =>
																										chat.morphable?.associations?.some(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
																									)
			}
			else if(this.selectedFilter == 3){
				// Clientes
				return this.$store.state.chats.chats.filter(chat => chat.morphable_type == "App\\Models\\User" && chat.morphable?.company_rol?.role_id == 4)
			}
			else if(this.selectedFilter == 4){
				// Profesionales / Empresas
				return this.$store.state.chats.chats.filter(chat => chat.morphable_type == "App\\Models\\User" && chat.morphable?.company_rol?.role_id != 4)
			}
			else if(this.selectedFilter == 5){
				// Profesionales / Empresas
				return this.$store.state.chats.chats.filter(chat => {
					return !chat.morphable?.associations?.some(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
																										&& chat.morphable_type == "App\\Models\\ProjectLine"
				})
			}

			return this.$store.state.chats.chats;
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
		queryRoute(){
			const chat_room_id = this.$route.query.id
			if(chat_room_id && this.selectedChatRoomId != chat_room_id){
				this.selectedChatRoomId = chat_room_id
			}
		},
		chatsRooms(newValue){
			if(newValue && newValue.length > 0 && parseInt(this.$route.query.user_id)){
				this.selectRoomFromSearch({id: parseInt(this.$route.query.user_id)})
			}
		},
		conversationMessages(){
			setTimeout(() => {
				this.scrollToBottom()
			}, 300);
			this.$nextTick(() => {
				if (this.$refs.messageInput) {
					this.$refs.messageInput.focus();
				}
			});
		},
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('chats/getUserChats')
				this.$store.dispatch('users/getUserFromCompany', {start: 0, limit: 300})
			}
		},
		// selectedChatRoomId(newValue, oldValue){
		// 	if(newValue && newValue != oldValue){
		// 		this.getSelectedChatRoomMessages()
		// 	}
		// }
	},
	beforeDestroy(){
		eventBus.$off('reloadChat', this._onReloadChat)
	},
	mounted(){
		this.scrollToBottom()
		if(this.selectedCompany){
			this.$store.dispatch('chats/getUserChats')
			this.$store.dispatch('users/getUserFromCompany', {start: 0, limit: 300})
		}
		if(this.chatsRooms && this.chatsRooms.length > 0 && parseInt(this.$route.query.user_id)){
			this.selectRoomFromSearch({id: parseInt(this.$route.query.user_id)})
		}
		const chat_room_id = this.$route.query.id || this.$route.params.id
		if(chat_room_id && this.selectedChatRoomId != chat_room_id){
			this.selectedChatRoomId = parseInt(chat_room_id)
		}
    eventBus.$on('reloadChat', this._onReloadChat)
	},
	methods: {
		getRoomTypeColor(room){
			if(room.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'black'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id == 4){
				return 'green'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id != 4){
				return '#524d4d'
			}
			else if (room.morphable_type == "App\\Models\\ProjectLine"){
				return '#FF120B'
			}
			return '#808080'
		},
		getRoomTypeStyle(room){
			if(room.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'background-color:white; color:black; border: 1px solid black;'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id == 4){
				return 'background-color:black;color: white;'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id != 4){
				return 'background-color:#524d4d;color: white;'
			}
			else if (room.morphable_type == "App\\Models\\ProjectLine"){
				return 'background-color:#FF120B;color: white;'
			}
			return 'background-color:#808080;color: white;'
		},
		getRoomType(room){
			if(room.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'Chat Prospecto'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id == 4){
				return 'Chat Cliente'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id != 4){
				return 'Chat Profesionales / Empresas'
			}
			else if (room.morphable_type == "App\\Models\\ProjectLine"){
				return 'Chat Grupal de Proyecto'
			}
			return 'Otro'
		},
		getRoomTypeIndicator(room){
			if(room.morphable?.associations?.every(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return 'prospect'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id == 4){
				return 'client'
			}
			else if(room.morphable_type == "App\\Models\\User" && room.morphable?.company_rol?.role_id != 4){
				return 'professional'
			}
			else if (room.morphable_type == "App\\Models\\ProjectLine"){
				return 'project_line'
			}
			return 'other'
		},
		getRoomName(room){
			if(room.name){
				return room.name
			}
			if(room.morphable_type == "App\\Models\\User"){
				return room.morphable.profile?.name + ' ' + room.morphable.profile?.lastname + ' ' + room.morphable.profile?.second_lastname
			}
			const project_name = room.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable.name || item.morphable.info?.project_details;
			}, null)
			return project_name
		},
		getRoomPl(room){
			if(room.morphable){
				return room.morphable?.number
			}
			return null
		},
		projectLineAssociations(item){
			// if(item.morphable?.associations){
			// 	const project_associations = item.morphable?.associations
			// 	return project_associations.map((association) => {
			// 		return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
			// 	})
			// }
			return item.morphable?.associations ? {associations: item.morphable?.associations, project_line_id: item.morphable?.id}:null
		},
		getAssociationType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM / Visita Técnica'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					return 'Otro'
			}
		},
		handleGoTo(association){
			if(association.morphable_type == 'App\\Models\\PreProject'){
				// this.$router.push({ name: 'PreProject', params: { id: association.morphable_id } })
				this.$store.commit('preprojects/setPreProjectModalId', association.morphable_id)
			}
			else if(association.morphable_type == 'App\\Models\\BotConversation'){
				// this.$router.push({ name: 'Conversation', params: { id: association.morphable_id } })
				this.$store.commit('crm/setCrmModalId', association.morphable_id)
			}
		},
		getRoomClientName(room){
			if(room.morphable_type != 'App\\Models\\ProjectLine' || room.morphable?.associations?.some(assoc => {
																											const conv = assoc.morphable;
																											return conv?.user && !conv?.client;
																										})
				){
				return null
			}
			if(room.name){
				return room.name
			}
			if(room.morphable_type == "App\\Models\\User"){
				return room.morphable.profile?.name + ' ' + room.morphable.profile?.lastname + ' ' + room.morphable.profile?.second_lastname
			}
			const project_name = room.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable.name || item.morphable.info?.project_details;
			}, null)
			return project_name
		},
		getRoomClientEmail(room){
			if(room.morphable_type == "App\\Models\\User"){
				return room.morphable.email
			}
			const client = room.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable?.client
			}, null)
			if(client){
				const user_email = `${client.email}`
				return user_email
			}
			const user = room.morphable?.associations.reduce((acc, item) => {
				return acc || item.morphable.user
			}, null)
			if(user){
				const client_name = `${user?.email}`
				return client_name
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this._onReloadChat()
		},
		_onReloadChat() {
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
			}
			if(this.search){
				data = {...data, ...{search: this.search}}
			}
			this.$store.dispatch('chats/getUserChats', data)
		},
		debounceGetSelectedChatRoomMessages: _debounce(function() { this.getSelectedChatRoomMessages() }, 2000),
		async createNewChatRoom(user){
			const user_id = user.id
			const room = await createUserChatRoom({user_id})
			if(room.code == 200){
				this.selectChatRoom(room.chat_room)
			}
		},
    scrollToBottom() {
      const container = this.$refs.messagesContainer;
			if(container){
				container.scrollTop = container.scrollHeight;
			}
    },
		isMyMessage(message){
			return message.user_id == this.$store.state.user?.userInfo?.id
		},
		selectChatRoom(room){
			console.log('Seleccionando sala:', room)
			this.selectedChatRoomId = room.id
		},
		async getSelectedChatRoomMessages(){
			const chat_room_id = this.selectedChatRoomId
			const messages = await getChatRoomMessages({chat_room_id})
			if(messages.code == 200){
				this.conversationMessages = messages.chat_room?.messages
			}
		},
		async sendMessage(){
			if(typeof this.new_message === 'string' && this.new_message.trim() !== ''){
				this.appendNewMessageTemp(this.new_message)
				const data = {
					chat_room_id: this.selectedChatRoomId,
					message: this.new_message
				}
				this.new_message = null
				const new_message = await addMessageToChatRoom(data)
				if(new_message.code == 200){
					this.conversationMessages = new_message.chat_room_messages
					this.$store.dispatch('chats/getUserChats')
				}
			}
		},
		appendNewMessageTemp(message){
			const add_message = {
				message,
				user_id: this.$store.state.user?.userInfo?.id
			}
			this.conversationMessages.push(add_message)
		},
	},
};
</script>

<style scoped>
	.chat-container{
		height: 100%;
	}
	.chat-list-item{
		cursor: pointer;
		border-bottom: 1px solid #cacaca;
	}
	.chat-list-item:hover{
		background: #e9e9e9;
	}
	.chat-list-item.selected-room{
		background: #e9e9e9;
	}
	.chat-room-list-container{
		border-right: 1px solid #cacaca;
		background: #fafafa;
		display: flex;
		flex-direction: column;
		max-width: 690px;
	}
	.chat-rooms-container{
		display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;
	}

	.v-text-field {
		align-items: center;
	}
	.chatbox-container{
		display: flex;
		flex-direction: column;
		background: white;
	}
	.messages-container{
		display: flex;
		flex-direction: column;
		padding: 10px;
		flex: 1;
		height: 100%;
		background-color: #FCFBFE;
		overflow-y: scroll;
		text-transform: none;
	}
	.user-input-container{
		flex: 0;
	}
	.user-input-inner-container{
		padding: 10px;
	}
	.single-message{
		background-color: rgb(213, 211, 211);
		border: 1px solid rgb(193, 191, 191);
		padding: 4px 8px;
		max-width: 80%;
		border-radius: 10px;
		font-size: 14px;
		margin-bottom: 8px;
		text-transform: none;
	}
	.single-message.self-user{
		background-color: rgb(217, 239, 217);
		border: 1px solid rgb(197, 232, 197);
		align-self: flex-end;
	}
	.nomessages{
		text-align: center;
		font-size: 14px;
		padding-top: 30px;
	}
	.custom-badge-counter-chat{
		background-color: green;
		z-index: 100;
		border-radius: 50%;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
</style>
<style>
	.chatbox-container .single-message p{
		margin-bottom: 0;
	}
</style>